import axios from "axios"

import promisify from "../helpers/promisify"
import { type CountryPhoneCode } from "../store/ducks/onefleetdevolucao/types"

export type SendFormValues = {
  recaptchaToken: string
  formId: string
  save?: boolean
} & ({
  type: "oneentrega"
  email: string
  name: string
  cpf: string
  clientPhone: string
  company: string
  licensePlate: string
  pickupDate: string
  hasCarProblem?: boolean
  carProblemDescription?: string
  surveyGrade: number
  surveyDescription: string
  carProblemImages?: string[]
  cnhImages: string[]
  licensePlateImages: string[]
  clientPicture: string
  clientSignatureImage: string
  recaptchaToken: string
  terms: boolean
  carKm: number
  model: string
  dealer: string
  consultantName: string
  consultantEmail: string
} | {
  type: "onedevolucao"
  terms?: boolean

  client: {
    name: string
    cpf: string
    email: string
    phone: string
    phoneCountryCode: CountryPhoneCode
    company: string
  }

  consultant: {
    name: string
    dealer: string
    cityAndState: string
    email: string
    phone: string
    phoneCountryCode: CountryPhoneCode
  }

  car: {
    returnDate: string
    licensePlate: string
    model: string
    carKm?: number
    hasDamageOrMissingItems: boolean
  }

  damagedOrMissingItems: {
    carProblemDescription: string
    accessoriesStatus?: Record<string, number>
    images?: Record<string, string[]>
  }

  images: {
    licensePlateFileList: string[]
    odometerFileList: string[]
    carFrontFileList: string[]
    carRightFileList: string[]
    carBackFileList: string[]
    carLeftFileList: string[]
  }

  signatures: {
    clientPicture: string
    cnhPicture: string
    clientSignatureImage: string
    consultantSignatureImage: string
  }
})

export interface PlateResponseData {
  Km_Atual: number
  Razao_Social: string
  Concessionaria_Entrega: string
  Modelo: string
  Cliente: string
}

async function sendForm<T extends SendFormValues = SendFormValues> (args: T) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const body: any = {
    type: args.type,
    formId: args.formId,
    save: args.save ?? false
  }

  switch (args.type) {
    case "oneentrega": {
      body.email = args.email
      body.name = args.name
      body.cpf = args.cpf
      body.company = args.company
      body.licensePlate = args.licensePlate
      body.pickupDate = args.pickupDate
      body.hasCarProblem = args.hasCarProblem
      body.carProblemDescription = args.carProblemDescription
      body.surveyGrade = args.surveyGrade
      body.surveyDescription = args.surveyDescription
      body.carProblemImages = args.carProblemImages
      body.cnhImages = args.cnhImages
      body.licensePlateImages = args.licensePlateImages
      body.clientPicture = args.clientPicture
      body.clientSignatureImage = args.clientSignatureImage
      body.terms = args.terms
      body.carKm = args.carKm
      body.model = args.model
      body.dealer = args.dealer
      body.clientPhone = args.clientPhone
      body.consultantEmail = args.consultantEmail
      body.consultantName = args.consultantName
      break
    }
    case "onedevolucao": {
      body.client = args.client
      body.consultant = args.consultant
      body.car = args.car
      body.damagedOrMissingItems = args.damagedOrMissingItems
      body.images = args.images
      body.signatures = args.signatures
      body.terms = args.terms
      break
    }
  }

  const headers = {
    Recaptcha: args.recaptchaToken,
    application: "checklist",
    "Content-Type": "application/json"
  }

  const response = await axios.post(
    `${process.env.REACT_APP_API_URI}/form`,
    body,
    {
      headers
    }
  )

  return response.data
}

async function getPlateInfo (
  plate: string,
  recaptchaToken?: string
): Promise<PlateResponseData> {
  const plateResponse = await axios.get(
    `${process.env.REACT_APP_API_URI}/plate/${plate}`,
    { headers: { Recaptcha: recaptchaToken, application: "checklist" } }
  )

  return plateResponse.data
}

console.log(`${process.env.REACT_APP_API_URI}/images`)

async function uploadImage (
  imageData: Blob,
  imageName: string,
  recaptchaToken?: string
): Promise<string> {
  const file64 = await promisify.blobTo64(imageData)

  const signedUri = await axios.put(
    `${process.env.REACT_APP_API_URI}/images`,
    {
      key: imageName,
      data: file64
    },
    { headers: { Recaptcha: recaptchaToken, application: "checklist" } }
  )

  return signedUri.data.signedURI as string
}

export default { sendForm, getPlateInfo, uploadImage }
